module.exports = __webpack_public_path__ + "img/login.bf2bad58.jpg";